import React from 'react';
import JobTrackerComponent from './JobTracker/JobTracker';

function Jobs() {
  return <JobTrackerComponent />;
}

export default Jobs;